const model = {
  cash_desk: {
    name: "касса на начало дня",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  cash_desk_start_day: {
    name: "касса на начало дня",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  }
};

module.exports = model;
